<div class="search-result-pager-content-list">
  <a
    class="page-item"
    [ngClass]="{'disabled': contentListSource.displayAll || contentListSource.page === 1}"
    (click)="prevPage()"
  >
    <span class="text-link">
      {{ 'TRANS__SEARCH_RESULT_PAGER__PREVIOUS' | translate }}
    </span>
  </a>

  @if (contentListSource.page > 5) {
    <a
      class="page-item"
      (click)="setPage(1)"
    >
      <span class="text-link">
        1
      </span>

      <span class="page-item-first-page">
        &hellip;
      </span>
    </a>
  }

  @for (page of getPages(); track $index) {
    <a
      class="page-item"
      [ngClass]="{'disabled': contentListSource.displayAll || contentListSource.page === page}"
      (click)="setPage(page)"
    >
      <span [ngClass]="{'current-page': page === contentListSource.page}">
        {{page}}
      </span>
    </a>
  }

  @if (maxPage > endPage) {
    <a
      class="page-item page-item-last-page"
      [ngClass]="{'disabled': contentListSource.displayAll || contentListSource.page === maxPage}"
      (click)="setLastPage()"
    >
      <span class="last-page-ellipsis">
        &hellip;
      </span>

      <span class="text-link">
        {{maxPage}}
      </span>
    </a>
  }

  <a
    class="page-item"
    [ngClass]="{'disabled': contentListSource.displayAll || contentListSource.page === maxPage}"
    (click)="nextPage()"
  >
    <span class="text-link">
      {{ 'TRANS__SEARCH_RESULT_PAGER__NEXT' | translate }}
    </span>
  </a>

  <div
    class="page-item"
    [ngClass]="{'disabled': contentListSource.displayAll || maxPage < 2}"
  >
    <span>
      |
    </span>
  </div>

  <a
    class="page-item"
    (click)="toggleDisplayAll()"
    [ngClass]="{'disabled': maxPage < 2 && !contentListSource.displayAll}"
  >
    @if (contentListSource.displayAll) {
      <span class="text-link">
        {{ 'TRANS__SEARCH_RESULT_PAGER__DO_NOT_DISPLAY_ALL' | translate }}
      </span>
    }
    @else {
      <span class="text-link">
        {{ 'TRANS__SEARCH_RESULT_PAGER__DISPLAY_ALL' | translate }}
      </span>
    }
  </a>
</div>
